import { ModifyContextState } from 'context/toastContext.js';
import React from 'react';
import { appDetailTypesSelector } from 'selectors/lib/appDetailTypesSelector.js';
import copy from 'copy-to-clipboard';
import { formatPhoneNumber } from 'lib/numUtils.js';
import { getHashMap } from 'lib/getHashMap.js';
import iconMap from '../../lib/iconMap.js';
import { useSelector } from 'react-redux';
import SVG from 'images/svg/SVG.js';
import getMessageSVG from 'lib/getMessageSVG.js';
import formatDate from "../../../../lib/date/formatDate";

const getContactDetails = (details = [], appTypes = null) => {
  const items = {};
  for (let i = 0; i < details.length; i++) {
    let item = { ...(details[i] || {}) };
    let appType = appTypes[item.detail_type_id] || {};
    let typeName = appType.type;
    item.text = item.value;
    if(typeName === "phone") {
      item.text = formatPhoneNumber(item.value);
    }
    if(typeName === "date") {
      item.text = formatDate(item.value);
    }
    if (details[i].detail_sub_type_id) {
      let subTypeMap = getHashMap(appType.sub_types);
      let subType = subTypeMap[item.detail_sub_type_id];
      if (subType) {
        item.typeText = `${details[i].label || subType.sub_type}`;
      }
    }
    if (items[typeName] === undefined) {
      items[typeName] = [item];
    } else {
      items[typeName].push(item);
    }
  }
  return { types: Object.keys(items), items };
};

const ContactCardDetails = ({ contact, editable = false, activeId = null, handleEditDetail = () => {} }) => {
  const detailTypes = useSelector(appDetailTypesSelector);
  const contactDetails = getContactDetails((contact || {}).details, detailTypes);

  const handleCopyClick = (n) => {
    copy(n.value, { format: 'text/plain' });
    ModifyContextState.setToastMessage('Copied!');
  };

  return (
    <div className="contact-card-details">
      {contactDetails.types.map((item, i) => (
        <div key={i} className="contact-detail">
          <SVG icon={iconMap[item] || getMessageSVG(item)} />
          <div className="contact-detail-items">
            {contactDetails.items[item].map((item, i) => (
              <span key={i} className={`contact-detail-item ${activeId === item.id ? 'strong' : ''}`}>
                <span className="text" data-title={'Copy'} onClick={() => handleCopyClick(item)}>
                  {item.text}
                  {item.typeText && <span className={'item-type'}>{item.typeText}</span>}
                </span>
                {editable && (
                  <button className={'btn btn--small btn-secondary ml-1'} onClick={() => handleEditDetail(item)}>
                    {activeId === item.id ? 'Editing' : 'Edit'}
                  </button>
                )}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactCardDetails;
